import { Injectable } from '@angular/core';
import { AngularFireDatabase, AngularFireList } from 'angularfire2/database';

@Injectable({
  providedIn: 'root'
})
export class ActivitiesService {

  activitiesList:AngularFireList<any>;
  constructor(private firebase:AngularFireDatabase) { }
  getActivitiesList(){
    this.activitiesList= this.firebase.list('activities');  

  }
}
